// Launch special — single source of truth for promotional pricing copy.
//
// To END the promotion everywhere (landing pricing cards, About copy, in-app
// paywall) set PROMO_ACTIVE to false. Nothing auto-expires: the real charge
// prices live in the RevenueCat dashboard, so the displayed price must never
// change on its own ahead of them, or the page would advertise one number
// while checkout takes another.
//
// IMPORTANT — the price-lock is a promise. "Lock this rate for life" means
// existing subscribers must keep paying the launch price forever. RevenueCat
// and Stripe honour this automatically because a subscriber keeps being
// charged the price of the product they originally bought. It only holds if
// these RevenueCat products are never deleted, replaced or migrated. To raise
// prices later, create NEW products and leave the launch ones live.
export const PROMO_ACTIVE = true;

export const PROMO_BADGE = 'Launch special';
export const PROMO_LOCK_SHORT = 'Your rate, locked for life';
export const PROMO_LOCK_LINE =
    'Subscribe during launch and lock this rate for life - your price never goes up, for as long as you stay subscribed.';
// Urgency about the OFFER, never about the crowd. No invented member counts:
// a fabricated "joined by N founders" figure is misleading advertising and
// there are currently no paying subscribers to count. Swap to a real live
// count only once the number stands up on its own.
export const PROMO_URGENCY = "Launch pricing won't last - lock your rate before it ends.";

// Displayed prices. These MUST stay in sync with the RevenueCat dashboard
// products and with PLANS in backend/routes/subscriptions.py.
export const PRICING = {
    plus: {
        monthly: '$4.95',
        monthlyWas: '$6.95',
        yearly: '$49.50',
        yearlyWas: '$69.50',
    },
    pro: {
        monthly: '$9.95',
        monthlyWas: '$14.95',
        yearly: '$99.50',
        yearlyWas: '$149.50',
    },
};

// Annual saving vs paying monthly for 12 months, both tiers land on 17%.
export const ANNUAL_SAVING_PCT = 17;
